<template>
  <section class="section">
    <div class="text-center center-block">
      <h1>En construcción</h1>
      <h3>Proximamente estará dispobible</h3>
      <hr>
      <img src="/images/bird.png" alt="">
    </div>
  </section>
</template>
<script>
  export default {}
</script>



// WEBPACK FOOTER //
// EnContstruccion.vue?2fdbdbb2